//verify-timesheet.ts
import { ProjectService } from "@/services/project/project.service";
import { SessionTimeoutService } from "@/services/session-timeout/session-timeout.service";
import { UserManagementService } from "@/services/user-management/user-management.service";
import { UserService } from "@/services/user/user.service";
import { VerifyTimesheetViewService } from "@/services/verify-timesheet/verify-timesheet-view.service";
import { VerifyTimesheetService } from "@/services/verify-timesheet/verify-timesheet.service";
import { ExportService } from "@/services/verify-timesheet/export.service";
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as moment from "moment";
import { forkJoin, Observable } from "rxjs";
import { map } from "rxjs/operators";
import Swal from "sweetalert2";
import * as XLSX from "xlsx-js-style";
import { MainTimesheet } from "../../class/main-timesheet";
import { User } from "../../class/user";
import { da } from "date-fns/locale";

@Component({
  selector: "app-verify-timesheet",
  templateUrl: "./verify-timesheet.component.html",
  styleUrls: ["./verify-timesheet.component.scss"],
})
export class VerifyTimesheetComponent implements OnInit {
  myControl = new FormControl();

  @ViewChild("closebutton") closebutton;

  _userMainTimesheetList!: MainTimesheet[];
  userId = localStorage.getItem("UserId");
  positionId = localStorage.getItem("positionId");
  rolename = localStorage.getItem("roleName");
  manager: any[];
  dataManager: any[];
  uniqueLeads: any[] = [];
  allLeads: any[] = []; // เก็บ lead ทั้งหมดสำหรับ dropdown

  // change tab
  nowTab = "1";
  position = localStorage.getItem("positionName");

  statusSummary: any[] = [];
  statusMap: any = {};

  yearList: number[];
  monthList: number[];
  empList: User[];
  empkeyword = "firstName";

  filteredOptions: Observable<User[]>;
  statusList: string[];
  searchlist: [];
  yearSelected: number = 2022;
  monthSelected: any;
  monthToSearch: number = undefined;
  fullNameSelected: string;
  searchValue: string = "";
  searchValueMonth: string = "";
  searchValueYear: string = "";
  selectedManager: number | "all" | null = null;
  checkMandayProject: any[];
  projectRemainingManday: any[] = [];
  checkProjectManday: any[] = [];

  employeeSelected: User;
  empToSearch: number;
  invalidEmail = false;
  statusSelected: string = "All";
  statusToSearch: string = "All";

  reason: string;
  isReasonInvalid = false;
  selectreject: MainTimesheet;

  isMobile: boolean = false;

  currentSelectedPage: number = 0;
  pageSize: number = 10;
  totalPages: number;
  indexpagingstart: number;
  pageIndexes: Array<number> = [];

  // Search
  isSearch: boolean = false;
  currentSearch = "";
  MonthSearch = "";
  YearSearch = "";

  // Column name
  booleanValue: any = false;
  colSort = "all";
  colId = "id";
  colEmployee = "employeeId.firstName";
  colDate = "month/year";
  pagingLength = 0;
  currentPage = 0;

  //selectedPage
  selectedPage: number = 0;

  // Pagination table
  startIndex = 0;
  dataLength = 0;

  currentUserID = parseInt(localStorage.getItem("UserId"));
  projectList: any[];
  projectListV2: any[];
  year: number;

  availableMonths: number[] = [];
  availableYears: number[] = [];

  getMonthNumbers(): number[] {
    return Array.from({ length: 13 }, (_, i) => i + 1);
  }

  getSortedYears(): number[] {
    const yearsToUse =
      this.availableYears && this.availableYears.length > 0
        ? this.availableYears
        : this.yearList || [];
    return yearsToUse.slice().sort((a, b) => b - a);
  }

  constructor(
    private _service: VerifyTimesheetService,
    private userManagementService: UserManagementService,
    private _route: Router,
    private sessionTimeoutService: SessionTimeoutService,
    private userService: UserService,
    private verifyTimesheetViewService: VerifyTimesheetViewService,
    private cdr: ChangeDetectorRef,
    private modalService: NgbModal,
    private projectService: ProjectService,
    private exportService: ExportService
  ) {}

  availableMonth: any;
  distinctYears: number[];


  ngOnInit(): void {

    this.checkScreenSize();
    console.log("Component initialized");

    this.verifyTimesheetViewService.getDistinctYear().subscribe((data) => {
      this.distinctYears = data;
    });

    this.exportService.fetAvaibleMonth().subscribe((data) => {
      this.availableMonth = data;
      console.log("month here", data);
    });

    if (
      this.positionId == "1" ||
      this.positionId == "6" ||
      this.positionId == "4"
    ) {
      this.userManagementService.getManager().subscribe((res) => {
        this.manager = res;
        console.log("Manager data:", this.manager);
        this.getDataByFilterWithPagingByUnderManager();
      });
    } else {
      this.getDataByFilterWithPaging();
    }

    const currentYear = moment().year();
    console.log("Current year:", currentYear);
    this.yearList = Array.from(Array(currentYear - 2022 + 1).keys())
      .map((x) => x + 2022)
      .sort((a, b) => b - a);
    console.log("Generated yearList:", this.yearList);

    this.getAllLead();
    this.monthList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    this.statusList = ["A", "P", "R", "N"];
    this.getEmployeeList();

    // Load available dates after yearList is initialized
    this.loadAvailableDates();

    this.sessionTimeoutService.ResetTime();
  }

    @HostListener('window:resize', ['$event'])
onResize(event?) {
  this.checkScreenSize();
}

  checkIsReason(): boolean {
    if (!this.reason || this.reason.trim() === '') {
      this.isReasonInvalid = true;
      return false;
    }
    this.isReasonInvalid = false;
    return true;
  }

  checkScreenSize() {
  this.isMobile = window.innerWidth < 440;
  if (this.isMobile) {
    this.pageSize = 99999; 
  } else {
    this.pageSize = 10;
  }
}

  @HostListener("mousemove")
  @HostListener("touchstart")
  ResetTime() {
    this.sessionTimeoutService.ResetTime();
  }
  displayProperty(user: User): string {
    return user && user.firstName && user.lastName
      ? user.firstName + " " + user.lastName
      : "";
  }

  getData() {
    this._service.fetchMainTimesheetList().subscribe((data) => {});
  }

  getEmployeeList() {
    this._service.getEmployeeMainTimesheetList().subscribe((data) => {
      this.empList.map(
        (emplist) =>
          (emplist.firstName = `${emplist.firstName} ${emplist.lastName}`)
      );
    });
  }

  getAllLead() {
    this.userManagementService.getAllLead().subscribe((res) => {
      this.dataManager = res;
      console.log(this.dataManager);
    });
  }

  updateUniqueLeads() {
    console.log("updateUniqueLeads called, data:", this._userMainTimesheetList);

    if (this._userMainTimesheetList && this._userMainTimesheetList.length > 0) {
      const leadMap = new Map();

      this._userMainTimesheetList.forEach((item: any) => {
        console.log("Processing item:", item.leadName, item.leadNickNameTh);

        if (item.leadName && item.leadNickNameTh) {
          const leadKey = `${item.leadName}_${item.leadNickNameTh}`;
          if (!leadMap.has(leadKey)) {
            leadMap.set(leadKey, {
              id: item.leadId || item.leadName,
              leadName: item.leadName,
              leadNickNameTh: item.leadNickNameTh,
              displayName: `${item.leadName} (${item.leadNickNameTh})`,
            });
          }
        }
      });

      this.uniqueLeads = Array.from(leadMap.values());

      // ถ้ายังไม่เลือก manager หรือเลือก null ให้ใช้ uniqueLeads ปัจจุบัน
      if (this.selectedManager === null) {
        this.allLeads = [...this.uniqueLeads];
      }

      console.log("Unique leads from table:", this.uniqueLeads);
      console.log("All leads for dropdown:", this.allLeads);
    } else {
      console.log("No data in _userMainTimesheetList");
      if (this.selectedManager === null) {
        this.allLeads = [];
      }
    }
  }

  sort(colName, boolean) {
    this.colSort = colName;
    this.booleanValue = !this.booleanValue;
    if (
      this.positionId == "1" ||
      this.positionId == "6" ||
      this.positionId == "4"
    ) {
      this.getDataByFilterWithPagingByUnderManager();
    } else {
      this.getDataByFilterWithPaging();
    }
  }

  counter(i: number) {
    return new Array(i);
  }

  changePage(page: number) {
    this.currentPage = page;
    this.startIndex = this.currentPage * 10;
    if (
      this.positionId == "1" ||
      this.positionId == "6" ||
      this.positionId == "4"
    ) {
      this.getDataByFilterWithPagingByUnderManager(this.nowTab);
    } else {
      this.getDataByFilterWithPaging();
    }
  }

  onYearSelectedChange(year: number) {
    this.getDataByFilterWithPaging();
  }

  onMonthSelectedChange() {
    if (this.monthSelected == 0) {
      this.monthToSearch = undefined;
    } else {
      this.monthToSearch = this.monthSelected;
    }
    // this.getDataByFilterWithPaging();
  }

  onEmpSelectedChange(emp: number) {
    this.getDataByFilterWithPaging();
  }

  onManagerChange() {
    console.log("Manager changed to:", this.selectedManager);
    // Reset pagination เมื่อเปลี่ยน manager
    this.currentPage = 0;
    this.startIndex = 0;

    if (
      this.positionId == "1" ||
      this.positionId == "6" ||
      this.positionId == "4"
    ) {
      this.getDataByFilterWithPagingByUnderManager();
    } else {
      this.getDataByFilterWithPaging();
    }
  }

  clearLeadSelection() {
    this.selectedManager = null;
    this.onManagerChange();
  }

  onEmployeeSelectedChange() {
    // this.getDataByFilterWithPaging();
    this.empToSearch = this.employeeSelected.id;
  }

  selectEvent(item) {
    this.empToSearch = item.id;
    // do something with selected item
  }

  // public displayProperty(value) {
  //   if (value) {
  //     return value.firstName;
  //   }
  // }

  onStatusSelectedChange() {
    if (this.statusSelected == "All") {
      this.statusToSearch = undefined;
    } else {
      this.statusToSearch = this.statusSelected;
    }
  }

  // onSearchlist() {
  //   this.onYearSelectedChange;
  //   this.onMonthSelectedChange;
  //   this.onEmpSelectedChange;
  //   this.onEmpSelectedChange;
  //   this.getDataByFilterWithPaging();

  // }

  // onSearchlist() {

  //   this._service
  //     .getMainTimesheetByFilter(
  //       this.monthSelected,
  //       this.yearSelected,
  //       this.fullNameSelected,
  //       this.statusSelected
  //     )
  //     .subscribe((res: any) => {
  //       this._userMainTimesheetList = res;
  //     });
  // }

  //use this method to call data
  // ************************************เปลี่ยนจาก tab:string="1" เป็น this.nowTab เพื่อเวลากดจะได้sort ตามแต่ละ tab***************************
  getDataByFilterWithPaging(tab: string = this.nowTab) {
  const pageSizeToUse = this.isMobile ? 99999 : this.pageSize;
  
  this._service
    .getMainTimesheetByFilterWithPaging(
      this.searchValue,
      tab,
      this.currentUserID,
      this.currentPage,
      pageSizeToUse, // ใช้ pageSize ตามขนาดหน้าจอ
      this.colSort,
      this.booleanValue,
      this.searchValueMonth,
      this.searchValueYear
    )
    .subscribe((data) => {
      this._userMainTimesheetList = data.content;
      this.pagingLength = data.totalPages;
      this.statusSummary = data.statusSummary;
      this.statusSummary.forEach((s) => {
        this.statusMap[s.timesheetStatus] = s.total;
      });
      console.log("dta: ", data);
      console.log("testData: " + data.content[0].month);

      this.updateUniqueLeads();
    });
}

  changeTab(tab: string) {
    console.log("TTTTTTTTT" + tab);

    this.nowTab = tab;
    this.currentPage = 0;
    this.startIndex = 0;
    this.colSort = "all";
    this.booleanValue = true;
    this.isSearch = false;
    this.searchValue = "";
    this.currentSearch = "";
    this.searchValue = "";
    this.searchValueMonth = "";
    this.searchValueYear = "";
    this.selectedManager = null;
    this.allLeads = [];

    if (
      this.position.includes("Human Resources") ||
      this.position.includes("Managing Director") ||
      this.position.includes("Project Management Officer")
    ) {
      this._userMainTimesheetList = [];
      this.getDataByFilterWithPagingByUnderManager(tab);
    } else {
      this._userMainTimesheetList = [];
      this.getDataByFilterWithPaging(tab);
      //this.dataUser = [];
      //this.showAllUserLeaveId(thisuserid, tab);
    }
  }
  // ************************************เปลี่ยนจาก tab:string="1" เป็น this.nowTab เพื่อเวลากดจะได้sort ตามแต่ละ tab***************************
  getDataByFilterWithPagingByUnderManager(tab: string = this.nowTab) {
  console.log("name จ้า : ", this.searchValue);
  console.log("month จ้า :", this.searchValueMonth);
  console.log("selectedManager จ้า :", this.selectedManager);

  const managerFilter =
    this.selectedManager === "all" || this.selectedManager === null
      ? null
      : this.selectedManager;
  
  const pageSizeToUse = this.isMobile ? 99999 : this.pageSize;

  this._service
    .getMainTimesheetByFilterWithPagingByUnderManager(
      this.searchValue,
      tab,
      this.manager,
      this.currentPage,
      pageSizeToUse, // ใช้ pageSize ตามขนาดหน้าจอ
      this.colSort,
      this.booleanValue,
      this.searchValueMonth,
      this.searchValueYear,
      managerFilter
    )
    .subscribe((data) => {
      this._userMainTimesheetList = data.content;
      this.pagingLength = data.totalPages;
      this.statusSummary = data.statusSummary;
      this.statusSummary.forEach((s) => {
        this.statusMap[s.timesheetStatus] = s.total;
      });
      console.log("dta: ", data);
      console.log("dtad: ", data.content);

      this.updateUniqueLeads();
    });
  console.log(this.pagingLength);
  console.log("userlist:", this._userMainTimesheetList);
}

  goToViewVerifyTimesheet(
    mainTimesheetId: any,
    MainTimesheetMonth: any,
    MainTimesheetYear: any
  ) {
    this._route.navigate(["/verify-timesheet-view", mainTimesheetId]);
  }

  
  onClickReject(rejectsentMainTimesheet: MainTimesheet) {
    this.selectreject = rejectsentMainTimesheet;
    Swal.fire({
      title: "Are you sure to reject?",
      // text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#007bff",
      cancelButtonColor: "#E5E5EA",
      confirmButtonText: "Yes, Reject it!",
      customClass: {
        confirmButton: "custom-swal-button",
        cancelButton: "custom-swal-button",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.userService
          .sendEmailForApproveTimeSheet(
            rejectsentMainTimesheet.id,
            rejectsentMainTimesheet.employeeId,
            "R"
          )
          .subscribe((data) => {
            this.invalidEmail = false;
          });
        Swal.fire("Reject!", "Your data has been rejected.", "success");
        this.selectreject = rejectsentMainTimesheet;
        this.selectreject.status = "R";
        this._service.updateMainTimesheet(this.selectreject).subscribe(
          (data) => {},
          (error) => {}
        );
        this.closebutton.nativeElement.click();
      }
    });
  }

  onClickRevise(MainTimesheet: MainTimesheet) {
    if (!this.checkIsReason()) {
      return;
    }

    Swal.fire({
    title: "Are you sure to revise?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#007bff",
    cancelButtonColor: "#E5E5EA",
    confirmButtonText: "Yes, Revise it!",
    customClass: {
      confirmButton: "custom-swal-button",
      cancelButton: "custom-swal-button",
      },
    }).then((result) => {
      if (result.isConfirmed) {

        MainTimesheet.status = "V";   
        MainTimesheet.reason = this.reason;
        MainTimesheet.revise = "1";

        this._service.updateMainTimesheet(MainTimesheet)
          .subscribe((data) => {

            console.log(data);

            this.modalService.dismissAll();
            this.reason = "";

            this.userService
              .sendMailTimesheet(
                MainTimesheet.id,
                MainTimesheet.employeeId,
                MainTimesheet.status
              )
              .subscribe((res) => {
                console.log(res);
              });
          });
      }
    });
  }
  
  onClickSave() {
    //ยังขาด เวลากด cancel ยังส่งค่า Reject เป็นค่าว่าง ''
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, reject it!",
        cancelButtonText: "No, cancel!",
        reverseButtons: true,
        customClass: {
          confirmButton: "custom-swal-button",
          cancelButton: "custom-swal-button",
        },
      })
      .then((result) => {
        if (result.isConfirmed) {
          swalWithBootstrapButtons.fire(
            "Reject!",
            "Your file has been reject.",
            "success"
          );
          this.selectreject.status = "R";
          this.selectreject.reason = this.reason;
          this._service.updateMainTimesheet(this.selectreject).subscribe(
            (data) => {},
            (error) => {}
          );
          this.reason = "";
          this.closebutton.nativeElement.click();
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
          swalWithBootstrapButtons.fire("Cancelled", "", "error");
        }
        this.reason = "";
        this.closebutton.nativeElement.click();
      });
  }

  onClickApprove(rejectsentMainTimesheet: MainTimesheet) {
  console.log("rejectsentMainTimesheet:", rejectsentMainTimesheet);

  Swal.fire({
    title: "Are you sure to approve?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#007bff",
    cancelButtonColor: "#E5E5EA",
    confirmButtonText: "Yes, Approve it!",
    customClass: {
      confirmButton: "custom-swal-button",
      cancelButton: "custom-swal-button",
    },
  }).then((result) => {
    if (!result.isConfirmed) return;

    this._service
      .checkMandayTimesheet(rejectsentMainTimesheet.id)
      .subscribe((res) => {
        this.checkMandayProject = res;

        const requests = this.checkMandayProject.map((element) =>
          this.projectService
            .getProjectRemainingManday(element.projectId)
            .pipe(
              map((projectData) => ({
                ...projectData,
                projectManday: element.projectManday,
              }))
            )
        );

        if (requests.length === 0) {
          console.log("No manday data, skip check → processApproval");
          this.processApproval(rejectsentMainTimesheet);
          return;
        }

        forkJoin(requests).subscribe((results) => {
          this.projectRemainingManday = results;
          this.checkProjectManday = [];

          this.projectRemainingManday.forEach((element) => {
            const {
              id,
              projectName,
              manday,
              remainingManday,
              projectManday,
            } = element;

            if (!manday) return;

            const actualRemaining = remainingManday ?? manday;
            const calManday = actualRemaining - projectManday;

            if (calManday < 0) {
              this.checkProjectManday.push({
                id,
                projectName,
                manday,
                remainingManday,
                projectManday,
                calManday,
              });
            }
          });

          if (this.checkProjectManday.length > 0) {
            const projectDetails = this.checkProjectManday
              .map((p) => `${p.projectName}: ${p.calManday} manday`)
              .join("<br>");

            Swal.fire({
              icon: "error",
              title: "Project manday is not enough!",
              html: projectDetails,
            });
            return; 
          }

          this.processApproval(rejectsentMainTimesheet);
        });
      });
  });
}

private processApproval(rejectsentMainTimesheet: MainTimesheet) {
  console.log("Enter ProcessApproval")
  if (rejectsentMainTimesheet.status === "P") {
    if (
      rejectsentMainTimesheet.reviseBy != null &&
      rejectsentMainTimesheet.reviseBy !== undefined
    ) {
      rejectsentMainTimesheet.status = "M";
    } else {
      rejectsentMainTimesheet.status = "A";
    }
  } else if (rejectsentMainTimesheet.status === "M") {
    rejectsentMainTimesheet.status = "A";
  }

  this.selectreject = rejectsentMainTimesheet;

  this._service.updateMainTimesheet(this.selectreject).subscribe({
    next: () => {
      console.log("Timesheet updated successfully");

      if (this.selectreject.status === "M") {
        this.userService
          .sendMailTimesheet(
            rejectsentMainTimesheet.id,
            rejectsentMainTimesheet.employeeId,
            "M"
          )
          .subscribe();
      } else if (this.selectreject.status === "A") {
        this.userService
          .sendEmailForApproveTimeSheet(
            rejectsentMainTimesheet.id,
            rejectsentMainTimesheet.employeeId,
            "A"
          )
          .subscribe();
      }

      Swal.fire({
        title: "Approve!",
        text: "Your data has been approved.",
        icon: "success",
      })
    },
    error: (error) => {
      console.error("Error updating timesheet:", error);
      Swal.fire({
        title: "เกิดข้อผิดพลาด!",
        text: "ไม่สามารถอัปเดตสถานะได้",
        icon: "error",
      });
    },
  });
}

  onCloseModel() {
    this.reason = "";
    this.closebutton.nativeElement.click();
  }

  onSearch() {
    if (
      this.searchValue == "" ||
      this.searchValue == null ||
      this.searchValueMonth == "" ||
      this.searchValueMonth == null ||
      this.searchValueYear == "" ||
      this.searchValueYear == null
    ) {
      this.isSearch = false;
    } else {
      this.isSearch = true;
    }
    // console.log("Month ===",this.searchValueMonth);
    // console.log("Year ===",this.searchValueYear);
    // console.log("Name ===",this.searchValue);
    // console.log("T h a d a Y e a m k e t".trim());

    if (this.searchValue == null) {
      this.searchValue = "";
    }
    if (this.searchValueMonth == null) {
      this.searchValueMonth = "";
    }
    if (this.searchValueYear == null) {
      this.searchValueYear = "";
    }

    this.searchValueMonth =
      this.searchValueMonth == "" ? null : this.searchValueMonth.trim();
    this.searchValueYear =
      this.searchValueYear == "" ? null : this.searchValueYear.trim();
    this.searchValue = this.searchValue == "" ? null : this.searchValue.trim();

    this.booleanValue = true;
    this.colSort = "all";
    this.currentPage = 0;
    this.startIndex = 0;
    if (
      this.positionId == "1" ||
      this.positionId == "6" ||
      this.positionId == "4"
    ) {
      this.getDataByFilterWithPagingByUnderManager();
    } else {
      this.getDataByFilterWithPaging();
    }
  }

  onClear() {
    this.searchValue = "";
    this.searchValueMonth = "";
    this.searchValueYear = "";
    this.isSearch = false;
    this.searchValue = "";
    this.currentSearch = "";
    this.currentPage = 0;
    this.colSort = "all";
    this.startIndex = 0;
    this.selectedManager = null;
    this.allLeads = []; // รีเซ็ต allLeads เมื่อกด Clear
    if (
      this.positionId == "1" ||
      this.positionId == "6" ||
      this.positionId == "4"
    ) {
      this.getDataByFilterWithPagingByUnderManager();
    } else {
      this.getDataByFilterWithPaging();
    }
  }

  clearSearch() {
    this.searchValue = "";
  }

  getMandayProjectAndExport(year: number): void {
    this.verifyTimesheetViewService
      .getMandayProjectbyYear(year)
      .subscribe((data: any[]) => {
        this.year = year;
        this.projectList = data;
        this.cdr.detectChanges();
        this.onExportMandaysData();
      });
  }

  getMandayProjectAndExportV2(year: number): void {
    // Show loading dialog
    Swal.fire({
      title: "Loading...",
      text: `Fetching Manday data for year ${year}`,
      allowOutsideClick: false,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading();
      },
    });

    console.log(`Fetching Manday data for year ${year}`);

    this.verifyTimesheetViewService.getMandayProjectbyYearV2(year).subscribe({
      next: (data: any[]) => {
        console.log(`Successfully received data for year ${year}:`, data);
        Swal.close(); // Close loading dialog

        if (!data || data.length === 0) {
          Swal.fire({
            title: "No Data Found",
            text: `No manday data found for year ${year}. Please check if there are approved timesheets for this year.`,
            icon: "warning",
            confirmButtonText: "OK",
          });
          return;
        }

        this.year = year;
        this.projectListV2 = data;
        this.cdr.detectChanges();
        this.onExportMandaysDataV2();
      },
      error: (error) => {
        console.error(`Error fetching Manday data for year ${year}:`, error);
        Swal.close(); // Close loading dialog

        let errorMessage = `Failed to fetch Manday data for year ${year}.`;

        if (error.status === 500) {
          errorMessage += ` Error: ${
            error.error?.message || "Internal Server Error"
          }`;
          if (
            error.error?.message?.includes("ArrayIndexOutOfBoundsException")
          ) {
            errorMessage +=
              "\n\nThis appears to be a data processing issue. Please contact the administrator.";
          }
        } else if (error.status === 0) {
          errorMessage += " Please check your network connection.";
        }

        Swal.fire({
          title: "Export Failed",
          text: errorMessage,
          icon: "error",
          confirmButtonText: "OK",
        });
      },
    });
  }

  exportMandayData(): void {
    const monthOptions: string[] = this.availableMonth.map((m) => {
      const monthNumber = parseInt(m);
      const date = new Date(2020, monthNumber - 1);
      const monthName = date.toLocaleString("default", { month: "long" });
      return `<option value="${m}">(${m}) ${monthName}</option>`;
    });

    Swal.fire({
      title: "Select Month for Site Cost Export",
      html: `
      <select id="swal-month-select" class="tw-w-[100%]">
        ${monthOptions.join("")}
      </select>
    `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Export",
      cancelButtonText: "Cancel",
      allowOutsideClick: false,
      preConfirm: () => {
        const selectEl = document.getElementById(
          "swal-month-select"
        ) as HTMLSelectElement;
        return selectEl.value;
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const selected = result.value;
        this.downloadMandayExcel(selected);
      }
    });
  }

  private downloadMandayExcel(month: number): void {
    const year = new Date().getFullYear();
    // Check if user is a project manager (has limited access)
    const currentUserID = parseInt(localStorage.getItem("UserId"));
    const isProjectManager = this.rolename.includes("MANAGER");

    const exportObservable = isProjectManager
      ? this.verifyTimesheetViewService.exportMandayProjectManager(
          year,
          month,
          currentUserID
        )
      : this.verifyTimesheetViewService.exportManday(year, month);

    exportObservable.subscribe({
      next: (blob: Blob) => {
        // Create download link
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `manday_report_${year}_${month}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        // Show success message
        Swal.fire({
          title: "Success!",
          text: `Manday report for ${year} has been downloaded successfully.`,
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        });
      },
      error: (error) => {
        console.error("Export error:", error);
        Swal.fire({
          title: "Export Failed",
          text: "There was an error exporting the Manday data. Please try again.",
          icon: "error",
          confirmButtonText: "OK",
        });
      },
    });
  }
  exportSiteCostData(): void {
    const monthOptions: string[] = this.availableMonth.map((m) => {
      const monthNumber = parseInt(m);
      const date = new Date(2020, monthNumber - 1);
      const monthName = date.toLocaleString("default", { month: "long" });
      return `<option value="${m}">(${m}) ${monthName}</option>`;
    });

    Swal.fire({
      title: "Select Month for Site Cost Export",
      html: `
      <select id="swal-month-select" class="tw-w-[100%]">
        ${monthOptions.join("")}
      </select>
    `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Export",
      cancelButtonText: "Cancel",
      allowOutsideClick: false,
      preConfirm: () => {
        const selectEl = document.getElementById(
          "swal-month-select"
        ) as HTMLSelectElement;
        return selectEl.value;
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const selected = result.value;
        this.downloadSiteCostExcel(selected);
      }
    });
  }

  private downloadSiteCostExcel(month: number): void {
    const year = new Date().getFullYear();
    const currentUserID = parseInt(localStorage.getItem("UserId"));
    console.log("user current", currentUserID);
    console.log("role", this.rolename);
    const isProjectManager = this.rolename.includes("MANAGER");

    const exportObservable = isProjectManager
      ? this.verifyTimesheetViewService.exportSiteCostProjectManager(
          year,
          month,
          currentUserID
        )
      : this.verifyTimesheetViewService.exportSiteCost(year, month);

    console.log(month, "month");

    exportObservable.subscribe({
      next: (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `site_cost_report_${year}_${month}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        Swal.fire({
          title: "Success!",
          text: `Site cost report for ${year} ${month} has been downloaded successfully.`,
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        });
      },
      error: (error) => {
        console.error("Export error:", error);
        Swal.fire({
          title: "Export Failed",
          text: "There was an error exporting the Site Cost data. Please try again.",
          icon: "error",
          confirmButtonText: "OK",
        });
      },
    });
  }

  @ViewChild("tableMandayProject") table: ElementRef;
  onExportMandaysData(): void {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
      this.table.nativeElement
    );

    for (let index = 0; index < this.projectList.length; index++) {
      const cellRef = "A" + (index + 6);
      const cell = ws[cellRef];
      cell.t = "s";
      cell.v = this.projectList[index][0];
      cell.s = { alignment: { horizontal: "center" } };
    }

    // Define column widths
    ws["!cols"] = [];
    ws["!cols"][0] = { width: 10 };
    ws["!cols"][1] = { width: 40 };
    ws["!cols"][15] = { width: 14 };

    // Define Row Style
    ws["A1"].s = {
      alignment: { horizontal: "center" },
      font: { bold: true, sz: 12 },
    };
    ws["A2"].s = { alignment: { horizontal: "center" }, font: { sz: 12 } };
    ws["A3"].s = { alignment: { horizontal: "center" }, font: { sz: 12 } };
    ws["A4"].s = { alignment: { horizontal: "center" }, font: { sz: 16 } };
    ws["D4"].s = { alignment: { horizontal: "center" }, font: { sz: 12 } };
    ws["A4"].s = {
      alignment: { wrapText: true, horizontal: "center" },
      font: { sz: 12 },
    };
    ws["B4"].s = {
      alignment: { wrapText: true, horizontal: "center" },
      font: { sz: 12 },
    };
    ws["C4"].s = {
      alignment: { wrapText: true, horizontal: "center" },
      font: { sz: 12 },
    };
    ws["P4"].s = {
      alignment: { wrapText: true, horizontal: "center" },
      font: { sz: 12 },
    };
    ws["Q4"].s = {
      alignment: { wrapText: true, horizontal: "center" },
      font: { sz: 12 },
    };
    ws["R4"].s = {
      alignment: { wrapText: true, horizontal: "center" },
      font: { sz: 12 },
    };
    ws["S4"].s = {
      alignment: { wrapText: true, horizontal: "center" },
      font: { sz: 12 },
    };

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, `${this.year}`);

    // Save the workbook as a file
    XLSX.writeFile(wb, `Project Manday ${this.year}.xlsx`);
  }

  @ViewChild("tableMandayProjectV2") tableV2: ElementRef;
  onExportMandaysDataV2(): void {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
      this.tableV2.nativeElement
    );

    /* To Make COL PROJECT CODE ALIGN CENTER */
    // for (let index = 0; index < this.projectListV2.length; index++) {
    //   const cellRef = 'A' + (index + 6);
    //   const cell = ws[cellRef];
    //   cell.t = 's';
    //   cell.v = this.projectListV2[index][0];
    //   cell.s = { alignment: { horizontal: 'center' } };
    // }

    ws["!cols"] = [];
    ws["!cols"][0] = { width: 10 };
    ws["!cols"][1] = { width: 40 };
    ws["!cols"][2] = { width: 20 };
    ws["!cols"][3] = { width: 10 };
    ws["!cols"][4] = { width: 10 };
    ws["!cols"][5] = { width: 10 };
    ws["!cols"][6] = { width: 10 };
    ws["!cols"][7] = { width: 10 };
    ws["!cols"][20] = { width: 15 };
    ws["!cols"][21] = { width: 15 };
    ws["!cols"][22] = { width: 15 };
    ws["!cols"][23] = { width: 15 };

    ws["A1"].s = {
      alignment: { horizontal: "center" },
      font: { bold: true, sz: 12 },
    };
    ws["A2"].s = { alignment: { horizontal: "center" }, font: { sz: 12 } };
    ws["A3"].s = { alignment: { horizontal: "center" }, font: { sz: 12 } };
    ws["A4"].s = {
      alignment: { wrapText: true, horizontal: "center" },
      font: { sz: 12 },
    };
    ws["B4"].s = {
      alignment: { wrapText: true, horizontal: "center" },
      font: { sz: 12 },
    };
    ws["C4"].s = {
      alignment: { wrapText: true, horizontal: "center" },
      font: { sz: 12 },
    };
    ws["D4"].s = {
      alignment: { wrapText: true, horizontal: "center" },
      font: { sz: 12 },
    };
    ws["E4"].s = {
      alignment: { wrapText: true, horizontal: "center" },
      font: { sz: 12 },
    };
    ws["F4"].s = {
      alignment: { wrapText: true, horizontal: "center" },
      font: { sz: 12 },
    };
    ws["G4"].s = {
      alignment: { wrapText: true, horizontal: "center" },
      font: { sz: 12 },
    };
    ws["H4"].s = {
      alignment: { wrapText: true, horizontal: "center" },
      font: { sz: 12 },
    };
    ws["U4"].s = {
      alignment: { wrapText: true, horizontal: "center" },
      font: { sz: 12 },
    };
    ws["V4"].s = {
      alignment: { wrapText: true, horizontal: "center" },
      font: { sz: 12 },
    };
    ws["W4"].s = {
      alignment: { wrapText: true, horizontal: "center" },
      font: { sz: 12 },
    };
    ws["X4"].s = {
      alignment: { wrapText: true, horizontal: "center" },
      font: { sz: 12 },
    };

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, `${this.year}`);

    // Save the workbook as a file
    XLSX.writeFile(wb, `Project Manday ${this.year}.xlsx`);
  }

  printText(data) {
    if (data == null || data == "") {
      return "";
    } else {
      return data.toString();
    }
  }

  printTextHighlight(data) {
    if (data == null || data == "") {
      return "";
    } else {
      return data.replace(
        new RegExp(this.currentSearch, "gi"),
        (match) => "<mark>" + match + "</mark>"
      );
    }
  }

  maxVisiblePages: number = 10;

  get pages(): number[] {
    const startPage = Math.floor(this.currentPage / 10) * 10 + 1;
    const endPage = Math.min(startPage + 9, this.pagingLength);
    return Array.from(
      { length: endPage - startPage + 1 },
      (_, i) => startPage + i
    );
  }

  visiblePages(): number[] {
    const pages = [];
    let startPage = Math.max(
      1,
      this.currentPage - Math.floor(this.maxVisiblePages / 2)
    );
    let endPage = startPage + this.maxVisiblePages - 1;

    if (endPage > this.pagingLength) {
      endPage = this.pagingLength;
      startPage = Math.max(1, endPage - this.maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return pages;
  }

  setPage(page: number): void {
    if (page < 0 || page > this.pagingLength) return;

    this.currentPage = page;
    this.startIndex = this.currentPage * 10;
    if (
      this.positionId == "1" ||
      this.positionId == "6" ||
      this.positionId == "4"
    ) {
      this.getDataByFilterWithPagingByUnderManager(this.nowTab);
    } else {
      this.getDataByFilterWithPaging();
    }
  }

  openDiaLogClick(content: any) {
    this.modalService.open(content, {
      size: "lg",
      centered: true,
      windowClass: "zinfexFixed",
    });
  }

  canEmployeeRevise(timesheet: MainTimesheet): boolean {
    // เช็คว่าสถานะต้องเป็น 'H' (HR Revised) เท่านั้น
    if (timesheet.status !== "H") {
      return false;
    }

    // ถ้าเป็น Admin
    if (this.rolename.includes("ADMIN")) {
      // ให้กดได้เฉพาะ Admin ที่เป็น Lead ของ Timesheet นั้นเท่านั้น
      return this.currentUserID === timesheet.leadId;
    }

    // ถ้าเป็น Manager
    if (this.rolename.includes("MANAGER")) {
      // กดได้ทุกคน เพราะแสดงแค่ทีมของตัวเอง
      return true;
    }

    return false;
  }

  onClickEmployeeRevise(timesheet: MainTimesheet) {
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#007bff",
      cancelButtonColor: "#E5E5EA",
      confirmButtonText: "Yes, Revise it!!!",
      cancelButtonText: "Cancel",
      customClass: {
        confirmButton: "custom-swal-button",
        cancelButton: "custom-swal-button",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // อัปเดตข้อมูล Timesheet
        timesheet.status = "V"; // เปลี่ยนสถานะเป็น Revising
        timesheet.reviseBy = timesheet.employeeId; // เก็บ ID พนักงาน
        timesheet.reviseDate = new Date(); // เก็บวันเวลาปัจจุบัน

        console.log("Sending Employee Revise:", {
          id: timesheet.id,
          status: timesheet.status,
          reviseBy: timesheet.reviseBy,
          reviseDate: timesheet.reviseDate,
        });

        // อัปเดต Timesheet
        this._service.updateMainTimesheet(timesheet).subscribe({
          next: (response) => {
            console.log("Update success:", response);

            // ส่งอีเมลแจ้งพนักงาน
            this.userService
              .sendMailTimesheet(timesheet.id, timesheet.employeeId, "RE")
              .subscribe({
                next: () => {
                  console.log("Email sent successfully");
                  Swal.fire({
                    title: "ส่งกลับสำเร็จ!",
                    text: "ส่ง Timesheet กลับให้พนักงานแก้ไขแล้ว",
                    icon: "success",
                    timer: 2000,
                    showConfirmButton: false,
                  }).then(() => {
                    // Refresh ข้อมูล
                    if (
                      this.positionId == "1" ||
                      this.positionId == "6" ||
                      this.positionId == "4"
                    ) {
                      this.getDataByFilterWithPagingByUnderManager();
                    } else {
                      this.getDataByFilterWithPaging();
                    }
                  });
                },
                error: (error) => {
                  console.error("Error sending email:", error);
                  Swal.fire({
                    title: "อัปเดตสำเร็จ!",
                    text: "อัปเดตสถานะสำเร็จ แต่อาจส่งอีเมลไม่ได้",
                    icon: "warning",
                    timer: 2000,
                    showConfirmButton: false,
                  }).then(() => {
                    if (
                      this.positionId == "1" ||
                      this.positionId == "6" ||
                      this.positionId == "4"
                    ) {
                      this.getDataByFilterWithPagingByUnderManager();
                    } else {
                      this.getDataByFilterWithPaging();
                    }
                  });
                },
              });
          },
          error: (error) => {
            console.error("Error updating timesheet:", error);
            Swal.fire({
              title: "เกิดข้อผิดพลาด!",
              text: "ไม่สามารถอัปเดตสถานะได้",
              icon: "error",
            });
          },
        });
      }
    });
  }

  onClickHrRevise(MainTimesheet: MainTimesheet) {
    if (!this.checkIsReason()) {
      return; 
    }
    console.log(this.isReasonInvalid)
    Swal.fire({
      title: "Are you sure to revise?",
      // text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#007bff",
      cancelButtonColor: "#E5E5EA",
      confirmButtonText: "Yes, Revise it!",
      customClass: {
        confirmButton: "custom-swal-button",
        cancelButton: "custom-swal-button",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        MainTimesheet.status = "H";
        MainTimesheet.reason = this.reason;
        MainTimesheet.revise = "1";
        MainTimesheet.reviseBy = Number(this.userId);
        this._service.updateMainTimesheet(MainTimesheet).subscribe((data) => {
          console.log(data);
          this.modalService.dismissAll();
          this.reason = "";
          this.userService
            .sendMailTimesheet(
              MainTimesheet.id,
              MainTimesheet.employeeId,
              MainTimesheet.status
            )
            .subscribe((data) => {
              console.log(data);
            });
        });
      }
    });
  }

  // Add these new methods
  loadAvailableDates() {
    console.log("Loading available dates...");
    this._service.getAvailableDates().subscribe({
      next: (dates: { years: number[]; months: number[] }) => {
        // Sort years from newest to oldest
        this.availableYears = dates.years.sort((a, b) => b - a);
        // Sort months from 1-12
        this.availableMonths = dates.months.sort((a, b) => a - b);
        console.log("Loaded dates:", {
          years: this.availableYears,
          months: this.availableMonths,
        });
      },
      error: (error) => {
        console.error("Error loading dates:", error);
        // Fallback to use yearList if API fails
        if (this.yearList && this.yearList.length > 0) {
          this.availableYears = this.yearList.slice();
        }
        // Set default months 1-12 if API fails
        this.availableMonths = Array.from({ length: 12 }, (_, i) => i + 1);
      },
    });
  }

  onYearChange() {
    if (this.searchValueYear) {
      this._service.getMonthsForYear(Number(this.searchValueYear)).subscribe({
        next: (months) => {
          // Sort months from 1-12
          this.availableMonths = months.sort((a, b) => a - b);
          console.log("Months for year:", months);
        },
        error: (error) => {
          console.error("Error loading months:", error);
        },
      });
    } else {
      this.loadAvailableDates();
    }
    this.filterResults();
  }

  onMonthChange() {
    if (this.searchValueMonth && !this.searchValueYear) {
      this._service.getYearsForMonth(Number(this.searchValueMonth)).subscribe({
        next: (years) => {
          // Sort years from newest to oldest
          this.availableYears = years.sort((a, b) => b - a);
          console.log("Years for month:", years);
        },
        error: (error) => {
          console.error("Error loading years:", error);
        },
      });
    }
    this.filterResults();
  }

  filterResults() {
    if (this.searchValueMonth || this.searchValueYear) {
      this.isSearch = true;
    }

    if (
      this.positionId == "1" ||
      this.positionId == "6" ||
      this.positionId == "4"
    ) {
      this.getDataByFilterWithPagingByUnderManager();
    } else {
      this.getDataByFilterWithPaging();
    }
  }

  exportMandayProjectYear() {
    const currentYear = new Date().getFullYear();

    Swal.fire({
      title:
        '<h1 style="font-weight:700;  padding:0 10px; font-size:30px; color:#333;">Select Project Status And Year For Manday Export</h1>',
      html: `
      <div style="
        display:flex; 
        flex-direction:column; 
        gap:1.5rem; 
        text-align:left; 
      ">
        <div>
          <select id="statusSelect" 
            class="swal2-input" 
            style="
              width:100%; 
              padding:5px; 
              border:1.5px solid #ccc; 
              border-radius:8px; 
              transition: all 0.2s ease; 
              font-size:18px;
            "
            onfocus="this.style.borderColor='#0d6efd'"
            onblur="this.style.borderColor='#ccc'"
          >
            <option value="N">Active Projects</option>
            <option value="Y">Inactive Projects</option>
            <option value="">All Projects</option>
          </select>
        </div>
        <div>
          <select id="yearSelect" 
            class="swal2-input" 
            style="
              width:100%; 
              padding:5px; 
              border:1.5px solid #ccc; 
              border-radius:8px; 
              transition: all 0.2s ease; 
              font-size:18px;
            "
            onfocus="this.style.borderColor='#0d6efd'"
            onblur="this.style.borderColor='#ccc'"
          >
            ${this.distinctYears
              .map(
                (y) =>
                  `<option value="${y}" ${
                    y === currentYear ? "selected" : ""
                  }>${y}</option>`
              )
              .join("")}
          </select>
        </div>
      </div>
    `,
      width: 700,
      showCancelButton: true,
      confirmButtonText: "Export",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#7B68EE",
      cancelButtonColor: "#BEBEBE",
      preConfirm: () => {
        const status = (
          document.getElementById("statusSelect") as HTMLSelectElement
        ).value;
        const year = (
          document.getElementById("yearSelect") as HTMLSelectElement
        ).value;
        return { status, year };
      },
    }).then((result) => {
      if (result.isConfirmed && result.value) {
        const { year, status } = result.value;
        this.downloadMandayExcelByStatus(year, status);
      }
    });
  }

  private downloadMandayExcelByStatus(year: string, status: string): void {
    Swal.fire({
      title: "Exporting...",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    let yearInt = parseInt(year);
    this.verifyTimesheetViewService
      .getMandayProjectYear(yearInt, status)
      .subscribe({
        next: (data: Blob) => {
          Swal.close();
          const url = window.URL.createObjectURL(data);
          const link = document.createElement("a");
          link.href = url;
          link.download = `Project_Manday_${year}_${status}.xlsx`;
          link.click();
          window.URL.revokeObjectURL(url);

          Swal.fire({
            icon: "success",
            title: "Export Successful!",
            text: `Report exported successfully for ${year}.`,
            timer: 2000,
            showConfirmButton: false,
          });
        },
        error: (error) => {
          Swal.close();
          Swal.fire({
            icon: "error",
            title: "Export Failed",
            text: "Error exporting the report. Please try again.",
          });
        },
      });
  }
}
